// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1AUjY","content":"ManualTimeModal_content__2YPM4"};